import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const CellMultiImg = ({ images, codePhoto, paymentProofPhoto, onClick, width = '80px', height = '60px', payWay }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // تحديد الصور المتاحة
  let availableImages = [];
  
  // إذا كان الدفع عبر PayPal، استخدم صورة إثبات الدفع
  if (payWay === 'paypal' && paymentProofPhoto) {
    availableImages = [paymentProofPhoto];
  }
  // معالجة الصور الجديدة (متعددة) للكود
  else if (images && Array.isArray(images) && images.length > 0) {
    availableImages = images.map((img, index) => {
      // إذا كان string مباشر (URL)
      if (typeof img === 'string') {
        return img;
      }
      
      // إذا كان object، تحقق من جميع الخصائص الممكنة
      if (img && typeof img === 'object') {
        // أولوية للـ URL الكامل
        if (img.url && typeof img.url === 'string') {
          return img.url;
        }
        
        // ثم secure_url
        if (img.secure_url && typeof img.secure_url === 'string') {
          return img.secure_url;
        }
        
        // إذا كان public_id، قم ببناء URL كامل
        if (img.publicId && typeof img.publicId === 'string') {
          const cloudinaryUrl = `https://res.cloudinary.com/dguqk7cs8/image/upload/${img.publicId}`;
          return cloudinaryUrl;
        }
        
        if (img.public_id && typeof img.public_id === 'string') {
          const cloudinaryUrl = `https://res.cloudinary.com/dguqk7cs8/image/upload/${img.public_id}`;
          return cloudinaryUrl;
        }
        
        return null;
      }
      
      return null;
    }).filter((url, index) => {
      // فلترة أكثر دقة - التأكد من أن URL صالح
      if (!url || typeof url !== 'string') {
        return false;
      }
      if (url.length < 10) {
        return false;
      }
      if (!url.startsWith('http') && !url.startsWith('/') && !url.startsWith('data:')) {
        return false;
      }
      
      return true;
    });
  }
  // إضافة الصورة القديمة (واحدة) للتوافق العكسي
  else if (codePhoto) {
    // معالجة codePhoto بنفس الطريقة
    if (typeof codePhoto === 'string') {
      availableImages = [codePhoto];
    } else if (codePhoto && typeof codePhoto === 'object') {
      if (codePhoto.url) {
        availableImages = [codePhoto.url];
      } else if (codePhoto.secure_url) {
        availableImages = [codePhoto.secure_url];
      } else if (codePhoto.publicId) {
        const cloudinaryUrl = `https://res.cloudinary.com/dguqk7cs8/image/upload/${codePhoto.publicId}`;
        availableImages = [cloudinaryUrl];
      } else if (codePhoto.public_id) {
        const cloudinaryUrl = `https://res.cloudinary.com/dguqk7cs8/image/upload/${codePhoto.public_id}`;
        availableImages = [cloudinaryUrl];
      }
    }
  }

  // تعريف الدوال أولاً
  const handleImageClick = () => {
    if (onClick) {
      // إرسال جميع الصور مع الفهرس الحالي
      onClick({
        images: availableImages,
        currentIndex,
        codePhoto: availableImages.length > 0 ? availableImages[0] : null // للتوافق العكسي
      });
    }
  };

  const handlePrevious = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex > 0 ? currentIndex - 1 : availableImages.length - 1;
    setCurrentIndex(newIndex);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex < availableImages.length - 1 ? currentIndex + 1 : 0;
    setCurrentIndex(newIndex);
  };

  // إذا لم توجد صور، عرض رسالة "لا توجد صور"
  if (availableImages.length === 0) {
    return (
      <Box
        sx={{
          width,
          height,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          overflow: 'hidden',
          cursor: 'pointer',
          border: '1px dashed #ccc'
        }}
        onClick={handleImageClick}
      >
        <Box
          component="img"
          src="/Main_Logo.png"
          alt="Hamam Logo"
          sx={{
            width: '60%',
            height: '60%',
            objectFit: 'contain',
            opacity: 0.5
          }}
        />
        <Typography
          variant="caption"
          sx={{
            fontSize: '8px',
            color: '#999',
            textAlign: 'center',
            mt: 0.5
          }}
        >
          Kein Bild
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width,
        height,
        borderRadius: '8px',
        overflow: 'hidden',
        cursor: 'pointer',
        border: '1px solid #ddd',
        '&:hover .navigation-buttons': {
          opacity: availableImages.length > 1 ? 1 : 0
        }
      }}
      onClick={handleImageClick}
    >
      {/* الصورة الحالية */}
      <Box
        component="img"
        src={availableImages[currentIndex]}
        alt={`Bild ${currentIndex + 1}`}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
        onError={(e) => {
          e.target.src = '/Main_Logo.png'; // fallback image
        }}
      />

      {/* أزرار التنقل - تظهر فقط إذا كان هناك أكثر من صورة */}
      {availableImages.length > 1 && (
        <>
          {/* زر السابق */}
          <IconButton
            className="navigation-buttons"
            onClick={handlePrevious}
            sx={{
              position: 'absolute',
              left: 2,
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0,0,0,0.5)',
              color: 'white',
              width: 20,
              height: 20,
              opacity: 0,
              transition: 'opacity 0.3s',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.7)'
              }
            }}
          >
            <ChevronLeft fontSize="small" />
          </IconButton>

          {/* زر التالي */}
          <IconButton
            className="navigation-buttons"
            onClick={handleNext}
            sx={{
              position: 'absolute',
              right: 2,
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0,0,0,0.5)',
              color: 'white',
              width: 20,
              height: 20,
              opacity: 0,
              transition: 'opacity 0.3s',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.7)'
              }
            }}
          >
            <ChevronRight fontSize="small" />
          </IconButton>

          {/* عداد الصور */}
          <Box
            className="navigation-buttons"
            sx={{
              position: 'absolute',
              bottom: 2,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: 'white',
              borderRadius: '8px',
              padding: '1px 4px',
              fontSize: '10px',
              opacity: 0,
              transition: 'opacity 0.3s'
            }}
          >
            {currentIndex + 1}/{availableImages.length}
          </Box>
        </>
      )}

      {/* مؤشر الصور المتعددة */}
      {availableImages.length > 1 && (
        <Box
          sx={{
            position: 'absolute',
            top: 2,
            left: 4,
            backgroundColor: 'rgba(0,0,0,0.7)',
            color: 'white',
            borderRadius: '8px',
            padding: '1px 4px',
            fontSize: '8px'
          }}
        >
          📸 {availableImages.length}
        </Box>
      )}
    </Box>
  );
};

export default CellMultiImg;